module.exports = __webpack_public_path__ + "img/5-1.3d2343ab.svg";